
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface TrendsHeaderProps {
  loading: boolean;
  trendingTopicsCount: number;
  communitiesCount: number;
  isManualRefreshing: boolean;
  onRefresh: () => void;
  onManualRefresh: () => void;
  isAdmin?: boolean;
}

export const TrendsHeader = ({
  loading,
  trendingTopicsCount,
  communitiesCount,
  isManualRefreshing,
  onRefresh,
  onManualRefresh,
  isAdmin = false
}: TrendsHeaderProps) => {
  return (
    <div className="text-center mb-6">
      <div className="flex items-center justify-center space-x-2 mb-2">
        <h1 className="text-2xl font-bold text-white">Trending Topics</h1>
        <Button 
          onClick={onRefresh} 
          variant="ghost" 
          size="sm" 
          className="text-white hover:text-white/80"
          disabled={loading}
        >
          <RefreshCw size={16} className={loading ? "animate-spin" : ""} />
        </Button>
      </div>
      <p className="text-white/90">Farming community insights</p>
      
      {/* Data freshness info */}
      <div className="flex items-center justify-center space-x-4 mt-2">
        <span className="text-xs text-white/70">
          {trendingTopicsCount} topics • {communitiesCount} communities
        </span>
{isAdmin && (
          <Button 
            onClick={onManualRefresh}
            variant="ghost" 
            size="sm" 
            className="text-xs text-white/70 hover:text-white"
            disabled={isManualRefreshing}
          >
            {isManualRefreshing ? "Updating..." : "Update from Posts"}
          </Button>
        )}
      </div>
    </div>
  );
};
